<!-- Menu toggle button -->
<a href="#" class="nav-link nav-pill" data-toggle="dropdown"> 
	<i class="far fa-bell"></i>
	<span *ngIf="notifications.length > 0" class="badge badge-warning navbar-badge">{{ notifications.length }}</span>
</a>
<div class="dropdown-menu ">
	<span class="dropdown-header">{{ youHaveNotifications }} {{notifications.length}} {{ notificationsText }}</span>
	<div class="dropdown-divider"></div>
	<ng-container *ngFor="let notif of notifications.reverse(); let i = index">

		<a class="dropdown-item" (click)="goToRoute(notif.link, notif.id)">
			<i class="{{notif.class}}"></i> {{notif.content}}
		</a>
	</ng-container>
			<!-- end notification -->
	
	<a class="dropdown-item" (click)="clearNotifi()">
		<i class="fa fa-trash"></i> {{ clearNotifications }}
	</a>

	<!-- <li class="footer">
		<a href="#">
			{{ 'NOTIFBOX.FOOTER' | translate }}
		</a>
	</li> -->
</div>